import {BaseAuthenticationMethod} from '@shared/models/signrequest/authentication/base-authentication-method';

export class CheckedID extends BaseAuthenticationMethod {
    type = 'checkedid';
    hideBsn?: boolean;
}
